import account from '@/api/accounts'

export default ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    account.getShopAuthToken(result => {
      resolve(result.data.data)
    }, param)
  })
}
